import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';
import contactform_list from './contactform.list';
import contactform_view from './contactform.view';

/**
 *   Create index file for Comment
 */

export default function ContactForm() {
  let {
    slug = 'list'
  } = useParams();
  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = contactform_list;
      break;
    case 'view':
      ActualPage = contactform_view;
      break;
    default:
      ActualPage = Theme404;
      break;
  }
  return <ActualPage />;
}